function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#44c7f4",
  d: "M26.1,35.7c5.4,11.6,12.1,16.2,22.8,16.2c71.2,0.1,66.6,0.5,137.7,0.8c3.1,0,6.1,0,9.2,0c0,0.8,0,1.6,0,2.4 c-58.6,0-41.4,0-100.1,0c1.5,9.6,6.5,12.8,17,13.7c5,0.5,86.1,1.5,86.1,1.5V35.4C116,35.4,110.8,35.7,26.1,35.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M20.8,14.1c-3.2,0-6.5,0-9.8,0c1,10.5,9.3,17.9,20.2,18c5.3,0.1,10.5,0.1,15.8,0.1h152v119.3h19.8V14 C218.7,14,83.6,14.1,20.8,14.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M278.9,62.8h-36c-7.6,0-11.3,3.7-11.3,11v66.8c0,7.3,3.8,11,11.3,11h36c7.4,0,11.2-3.7,11.2-11V73.8 C290.1,66.5,286.4,62.8,278.9,62.8z M270.4,134.9h-19.1V79.6h19.1V134.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M349.1,62.8h-34c-7.6,0-11.3,3.7-11.3,11v16.6H322V77.8h19.3v20.4H314c-7.6,0-11.3,3.7-11.3,11v32 c0,7.2,3.7,10.8,11,10.8c3.1,0,7.6-0.4,13.6-1.3c4.6-0.7,9.1-1.4,13.7-2.1v3.1h19.3V73.8C360.3,66.5,356.6,62.8,349.1,62.8z M341.2,135.6l-19.3,0.7v-24.5h19.3V135.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#345670",
  d: "M421.2,62.5c-3.7,0-8.4,0.5-14.1,1.4c-4.6,0.7-9.3,1.4-14,2.2v-3.3H373v88.8h20.1V80l18.9-0.4v72h20.2V73.3 C432.2,66.1,428.5,62.5,421.2,62.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#44c7f4",
  d: "M486.5,31.5h-14.8v31.3h12.8V80h-12.8v71.6h-20V80h-9.1V62.8h9.1V25c0-7.3,3.7-11,11.2-11h23.6V31.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#44c7f4",
  d: "M553.5,140.6c0,7.3-3.7,11-11.2,11h-36c-7.6,0-11.3-3.7-11.3-11V73.8c0-7.3,3.8-11,11.3-11h36 c7.4,0,11.2,3.7,11.2,11V140.6z M533.8,134.9V79.6h-19.1v55.3H533.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#44c7f4",
  d: "M622.3,99.9h-20V79.6L586.4,80v71.6h-20.1V62.8h20.1v3.3c4.2-0.8,8.3-1.5,12.4-2.3c5-0.9,9.1-1.3,12.5-1.3 c7.3,0,11,3.6,11,10.8V99.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#44c7f4",
  d: "M690.9,140.6c0,7.3-3.7,11-11.2,11h-34.9c-7.6,0-11.3-3.7-11.3-11V73.8c0-7.3,3.8-11,11.3-11h34.9 c7.4,0,11.2,3.7,11.2,11v21.1h-19.6V79.6h-18v55.3h18v-17h19.6V140.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#44c7f4",
  d: "M761,140.6c0,7.3-3.8,11-11.3,11h-34.7c-7.6,0-11.3-3.7-11.3-11V73.8c0-7.3,3.8-11,11.3-11h34.7 c7.6,0,11.3,3.7,11.3,11v32.6l-5.5,5.5h-32.6v24.9h18.9v-14.8H761V140.6z M741.8,98.9V77.6h-18.9v21.3H741.8z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 772 166",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/loanforce-logo.bc7d835b.svg";
export { SvgComponent as ReactComponent };